const covertInputData =(data)=>{  
    let obj ={}
    data.map((item)=>{
        obj = Object.assign(obj, item.input)
    })
    return obj
} 

const getCompleteOld =async(data,input)=>{  
    let complete = []
    await data.map((item,index)=>{
        complete.push({step:index,key:[]})
        setComplete(complete[index],[item],index)
    })
    let completeAll = []
    await input.map((item =>{
        let filter = complete.filter(filter => filter.step === item.step)
        if (filter.length > 0) {
            filter[0].key.map((key)=>{
                if (key !==  "5cd29aa53fa34e30e056e47c1561806169890" &&
                    key !==  "5cd29aa53fa34e30e056e47c1561812085875" &&
                    key !==  "5cd29aa53fa34e30e056e47c1561812357233" &&
                    key !==  "5cd29aa53fa34e30e056e47c1561816549340") { 
                    completeAll.push(key)
                }
                
            })
        }
        
    }))
    return completeAll
} 

const setComplete = async(complete,components,index)=>{
  
    await components.map(async(component)=>{
        complete.key.push(component.key)

        if (component.children.length > 0) {
            await setComplete(complete,component.children,index) 
        }else{
            
        }
    })
}

export {covertInputData,getCompleteOld}